module.exports = __webpack_public_path__ + "static/media/arrowright.578e5e81.svg";